/* eslint-disable semi,no-console */
import React, { Component } from 'react';
import { ThemeProvider, defaultTheme,LoadingScreen} from '@nike/ruxac';
import Filters from './Components/Filters';
import {connect} from 'react-redux';
import Header from './Components/Header';
import Sticky from 'react-stickynode';
import {checkForToken, login, authorizeUser} from './APIs/loginHelper';
import 'react-s-alert/dist/s-alert-default.css';
import {setAuthorizedState} from "./Actions/loginHandler";
import {setErrorState} from "./Actions/errorHandler";
import PartFilters from "./Components/PartsFilters";
import LaborProcessFilters from'./Components/LaborProcess';
import {downloadJSON} from './APIs/dataHelper';
import {setIsFileDownloaded} from './Actions/download';
import { ErrorMessage } from './Components/ErrorMessage';
import { DownloadMessage } from './Components/DownloadMessage';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from "glamor";
import * as adGroups from './Libs/userGroup';

class App extends Component {
    async componentDidMount() {
        const jwt = checkForToken();
        if(location.search){
            localStorage.setItem('params',location.search);
        }
        if (!jwt || !jwt.accessToken) {
            //redirect to SSO if detects query string has been entered and no jwt present
            login();
        }
        else{
            let urlParams = new URLSearchParams(localStorage.getItem ('params'));
            const filename = urlParams.get('fileName');
            const reportType = urlParams.get('reportType');
            localStorage.removeItem ('params');
            if(filename && reportType){
                this.props.setIsFileDownloaded(false);
                this.props.downloadJSON(jwt.accessToken,filename,reportType);
            }
            else {
                this.props.authorizeUser(jwt.accessToken, jwt.username);
            }

        }
    }

    render() {
        const filename = location.search.split('fileName=')[1];
        const isLoadingState = this.props.loadingIndicator.isLoadingData;
        return (
            <ThemeProvider theme={defaultTheme}>
                <div className="container-app">
                    {filename && !this.props.error.code && (!this.props.fileDownload.isDownloaded ?
                        <DownloadMessage message = {"File download will begin in few seconds..."} /> :
                        <DownloadMessage message = {"File download complete"} />)
                    }
                    {!filename  && (
                        <Sticky
                            enabled={true}
                            top={0}
                            innerZ={1000}
                        >
                            <Header />
                        </Sticky>
                    )}

                    {!filename  && (
                        <LoadingScreen
                            isLoading={isLoadingState && !this.props.login.isAuthorized}
                            loadingMessage='Loading...'
                        />
                    )}
                    {!filename  && (
                        <div className="container-App">
                            {!this.props.error.code && this.props.login.isAuthorized && (
                                <div className={`filter-container-outer shadowBox `}>
                                    <div className={`filter-container-outer shadowBox `}>
                                        {(this.props.userGroups.includes(adGroups.MATERIAL_FILTER) || this.props.userGroups.includes(adGroups.MATERIAL_FILTER_EXT)) && <Filters/>}
                                        {(this.props.userGroups.includes(adGroups.BOM_PARTS_FILTER) || this.props.userGroups.includes(adGroups.BOM_PARTS_FILTER_EXT)) && <PartFilters />}
                                        {(this.props.userGroups.includes(adGroups.LABOR_PROCESS_FILTER) || this.props.userGroups.includes(adGroups.LABOR_PROCESS_FILTER_EXT)) && <LaborProcessFilters />}
                                        <div className={'row'}>
                                            <div className={`date`}>
                                    * Dates are based on Last Updated Date stored in GMT
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                    {this.props.error.code && <ErrorMessage message={this.props.error.message}></ErrorMessage>}

                    <ToastContainer
                        bodyClassName   = {css({
                            fontSize  : "15px",
                            textAlign : "center"
                        })}
                        position        = {toast.POSITION.TOP_RIGHT}
                        autoClose       = {8000}
                        hideProgressBar = {false}
                    />
                </div>
            </ThemeProvider>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        data             : state.data.payload,
        loadingIndicator : state.loadingIndicator,
        error            : state.errorHandler,
        login            : state.loginHandler,
        userGroups       : state.userInfo.userGroups,
        fileDownload     : state.fileDownload
    };
};

const mapDispatchProps = {
    setAuthorizedState,
    setErrorState,
    authorizeUser,
    downloadJSON,
    setIsFileDownloaded
};
export default connect(mapStateToProps, mapDispatchProps)(App);



// WEBPACK FOOTER //
// ./src/App.js